import React from 'react';
import {
  IoDocumentOutline,
  IoDocumentTextOutline,
  IoEaselOutline,
  IoGridOutline,
  IoImageOutline,
} from 'react-icons/io5';
import { libraryKind } from './fileKinds';

// One icon per library kind, shared by the chat chips, the document viewer and
// the File Browser so a file looks the same wherever it shows up.
const KIND_ICONS = {
  pdf: IoDocumentTextOutline,
  spreadsheet: IoGridOutline,
  document: IoDocumentTextOutline,
  presentation: IoEaselOutline,
  image: IoImageOutline,
  other: IoDocumentOutline,
};

export function FileKindIcon({ file, size = 16, className }) {
  const kind = libraryKind(file);
  const Icon = KIND_ICONS[kind] || IoDocumentOutline;
  return (
    <Icon
      size={size}
      className={['file-kind-icon', `file-kind-${kind}`, className].filter(Boolean).join(' ')}
      aria-hidden="true"
    />
  );
}

/** `file` may be a FileRow, a chat chip or a composer attachment ({ name, mimeType }). */
export function fileKindIcon(file, size = 16) {
  return <FileKindIcon file={file} size={size} />;
}
